<div [hidden]="!show">
    <div [class]="cssClass">
        <div [hidden]="!show">
            
            <i class="fa-solid fa-spinner fa-pulse fa-5x fa-fw"></i>
        </div>
    </div>
</div>